import React from "react";
import { useIntl } from "react-intl";
import { translatedName } from "../../helpers/translations";

const modifierBreakdown = (menuItem: any, outOfStock: boolean) => {
  const intl = useIntl();

  let modifier = menuItem.groups.map((group: any) => {
    let groups = group.items.map((item: any) => {
      let selected_item;
      if (item.selected === true) {
        selected_item = item;
      }
      return (
        selected_item ? (
          <div 
            className={`modifier ${outOfStock ? "unavailable" : ""}`}
            key={selected_item.id}
          >
            {translatedName(selected_item, intl.locale)}
          </div>
        ) : false
      );
    });
    return groups;
  });
  return modifier;
}

export { modifierBreakdown };
